import * as React from 'react'
import { useRef } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useSelector } from 'react-redux'
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem } from '@mui/material'
import { findCode, printVariable, searchSchool } from '@util/helper'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import { useMediaQuery, useTheme } from '@mui/material'
import WebService from '@util/webService'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import useAlert from '@hooks/useAlert'
import axios from 'axios'
import { Fragment, useState } from 'react'
import moment from 'moment'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import MyTableHead from '@components/MyTableHead'
import ConfirmDialog from '@components/ConfirmDialog'
import Autocomplete from '@mui/material/Autocomplete'
import { Grid } from '@mui/material/'
import Box from '@mui/material/Box'

const ManagerRegiPartAgency = ({ record, dialogHandler, student, callback }) => {
  console.log('ManagerRegiPartAgency rendering...')
  console.log('record=>', record)
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const [dataList, set_dataList] = React.useState([])
  const [studentList, set_studentList] = React.useState([])
  const [targetStudent, set_targetStudent] = useState(student)
  const [smstList, set_smstList] = useState([])

  // redux
  const codes = useSelector((state) => state.codeReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const popTitle = +record.smstPhase === 0 ? '강좌 우선신청' : '강좌 대리신청'
  const fields = [
    { field: 'id', placeholder: '', type: 'text', value: -1, visible: false, canSrch: false, selList: [] },
    { field: 'regTime', placeholder: '일시', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'name', placeholder: '이름', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'schoolId', placeholder: '학교명', type: 'auto', value: '', visible: false, canSrch: true, selList: [] },
    { field: 'grade', placeholder: '학년', type: 'number', value: '', visible: true, canSrch: true, selList: [] },
    { field: 'className', placeholder: '반', type: 'text', value: '', visible: true, canSrch: true, selList: [] },
    { field: 'classNum', placeholder: '번호', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'gdnPhone', placeholder: '보호자 전화 번호', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'statName', placeholder: '상태', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'remark', placeholder: '비고', type: 'text', value: '', visible: false, canSrch: false, selList: [] },
  ]

  const respectGradeRef = useRef({ checked: true })
  const respectScheduleRef = useRef({ checked: true })

  const filterOptions = (options, state) => {
    let newOptions = []
    newOptions = options.filter((o) => o.name.includes(state.inputValue)).slice(0, 10)
    return newOptions
  }

  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    } else {
      dialogHandler[1](false)
    }
  }

  const onChangeSmstId = (e) => {
    const smst = smstList.find((r) => r.id === e.target.value)
    if (smst) {
      set_smst(smst)
    }
  }

  const onLoad = async () => {}

  const searchStudent = async (word) => {
    // 4 byte korean check
    const regex = /[\uAC00-\uD7AF]+/g

    //
    const regex2 = /[a-zA-Z]{2,}/g
    if (!regex.test(word) && !regex2.test(word)) {
      return []
    }

    const url = `/student/school/name/${schola.id}/${word}`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      openSnackbar(resp.repMessage)
      return []
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    for (const record of records) {
      // record.label = `${record.name}(${record.gdnPhone})`
      record.label = `${record.name}(${record.grade}학년, ${record.className}반, ${record.classNum}번)`
    }
    return records
  }

  const fetchSmstList = async () => {
    const url = `/smst/last/2/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url, {})
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const smstList = JSON.parse(repMessage.records)
    return smstList.filter((r) => r.phase != 2)
  }

  const preCheck = async () => {
    const url = `/regi/sel/student`
    const params = { lectureId: record.id }
    const resp = await WebService.get(url, params)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return false
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)

    if (records.length > 0) {
      const idx = records.findIndex((r) => r.id === targetStudent.id)
      if (idx >= 0) {
        alert('이미 수강 신청 데이터가 존재합니다.')
        return false
      } else {
        return true
      }
    }

    return true
  }

  const onSubmit = async () => {
	const urlPrefix  = +record.smstPhase == 0 ? `/regi/req/prior/agency` : `/regi/req/agency`
    const url = `${urlPrefix}/${schola.id}/${record.id}/${targetStudent.id}`
    const params = {
      respectGrade: respectGradeRef.current.checked,
      respectSchedule: respectScheduleRef.current.checked,
    }

    const resp = await WebService.post(url, {}, params)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
    } else {
      alert('처리되었습니다.')
      if (callback) {
        callback()
      }
      // handleClose()
    }
  }

  React.useEffect(() => {
    if (dialogHandler[0]) {
      onLoad()
    }
  }, [dialogHandler[0]])

  return (
    <Fragment>
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          {/*<Typography variant='h5' align='center'>*/}
          {/*  {record.title} 강좌 대리 신청*/}
          {/*</Typography>*/}
          <Box className={'center'}>
            <Typography variant="h5" sx={{ fontWeight: 'bold' }} align="center">
              {record.title}
            </Typography>
            <Typography variant="h5" sx={{ margin: 1 }}>
              {popTitle}
            </Typography>
          </Box>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent sx={{ minHeight: '10em' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={6}>
                  <label>
                    <input type="checkbox" defaultChecked={true} ref={respectGradeRef} /> 대상학년 검사
                  </label>
                </Grid>
                <Grid item xs={6}>
                  <label>
                    <input type="checkbox" defaultChecked={true} ref={respectScheduleRef} /> 일정중복 검사
                  </label>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Autocomplete
                  fullWidth
                  disablePortal
                  options={studentList}
                  filterOptions={filterOptions}
                  onInputChange={async (event, value, reason) => {
                    if (reason === 'input') {
                      const records = await searchStudent(value)
                      set_studentList(records)
                    }
                  }}
                  value={targetStudent}
                  onChange={async (e, v) => {
                    set_targetStudent(v)
                  }}
                  size="small"
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label="학생명" />}
                />
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button variant="outlined" onClick={handleClose}>
            닫기
          </Button>
          <ConfirmDialog
            btn={
              <Button disabled={!targetStudent} color={'primary'} variant="contained">
                신청
              </Button>
            }
            title={'주의'}
            content={'현재 강좌상태에 맞추어 신청됩니다. 신청하시겠습니까?'}
            bc={'primary'}
            preHandle={async () => {
              return await preCheck()
            }}
            perform={() => {
              onSubmit()
            }}
          />
        </DialogActions>
      </Dialog>

      {renderSnackbar()}
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
  )
}

export default ManagerRegiPartAgency
